module.exports = __webpack_public_path__ + "static/media/logo_cibrius_familia.8d655249.png";